import styled from 'styled-components'
import { primaryColor, primaryFont, wMedium, secondaryFont, primaryHeadingColor, scrollbar, SecondaryColor } from '../../../Utils/utilsStyle';
import { Executive, PersonalityInsights } from '../../../Types/PersonTypes';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../Slice/PersonProfileSlice';
import { actions as companyActions } from '../../../Slice/CompaniesSlice';
import classNames from 'classnames';
import InfiniteScroll from 'react-infinite-scroll-component';
import { selectNotableStaff, selectNotableStaffCount, selectNotableStaffLoading, selectNotableStaffPage } from '../../../Selector/CompaniesSelector';
import AffinitySearchResultItemSkeleton from '../../common/skeleton/AffinitySearchResultItemSkeleton';
import { selectAffinitySelectedPersonId, selectedSalesPopoverExtendedLoaded, selectedSalesPopoverExtendedLoading, selectedSalesPopoverLoaded, selectedSalesPopoverLoading, selectedSalesPopoverPeopleData, selectedSalesPopoverResultsPage, selectExtendedLoading, selectExtendedSearchLoaded, selectLoading, selectPeopleData, selectSearchLoaded, selectSearchResultsPage } from '../../../Selector/AffinitySearchSelector';
import { useEffect, useState } from 'react';
import { SearchResultSection, SearchResultsRequest } from '../../../Types/AffinitySearchTypes';
import { SalesAlignmentItem } from '../../../Types/GlobalTypes';
import { selectAlignmentPeopleStaff, selectSearchedMultiSalesPerson, selectSearchedMultiSalesPersonLoading, selectSearchedPerson, selectSearchedPersonData } from '../../../Selector/PersonProfileSelector';
import AlignmentPopoverList from './AlignmentPopoverList';
import { getLangCookie, validateSearchQuery } from '../../../Utils/UtilityFunctions';
import { actions as affinityActions } from '../../../Slice/AffinitySearchResultsSlice';
import { actions as helperActions } from '../../../Slice/HelperSlice';
const ContentWrapper = styled.div`
  border-radius: 14px;
  background: #FFF;
  height: 280px;
  width: 230px;
  &.noStaff {
    .empty-list {
      width: 100%;
      height: 80%;
    }
  }
`;
type Props = {
  personsList: SalesAlignmentItem[];
  basePersonId: number
  rowId: number;
  currentCompanyId: number;
  closePopover: () => void;
  searchedPersonSelected: boolean;
};
const defaultProps = {
  personsList: [],
  basePersonId: 0,
  rowId: 0,
  currentCompanyId: 0,
  searchedPersonSelected: false,
};

const SalesAlignmentPopover = function SalesAlignmentPopover(props: Props) {
  const {
    personsList, basePersonId, rowId, currentCompanyId, closePopover, searchedPersonSelected } = props;
  const [query, setQuery] = useState('');
  const dispatch = useDispatch();
  const alignmentStaff = useSelector(selectAlignmentPeopleStaff(rowId));
  const { page: staffPage, count: totalStaff, loading: staffLoading, staff: staffData } = alignmentStaff;
  const personIds = personsList.map(item => item.person.personId);
  const disabledIds = [...personIds, basePersonId];
  const loading: boolean = useSelector(selectedSalesPopoverLoading(rowId));
  const extendedLoading: boolean = useSelector(selectedSalesPopoverExtendedLoading(rowId))
  const loaded: boolean = useSelector(selectedSalesPopoverLoaded(rowId));
  const extendedLoaded: boolean = useSelector(selectedSalesPopoverExtendedLoaded(rowId));
  const peopleData: SearchResultSection = useSelector(selectedSalesPopoverPeopleData(rowId));
  const { count, linkedInCount } = peopleData ?? {};
  const totalSearchCount = linkedInCount ? count + linkedInCount : count;;
  const salesPage: number = useSelector(selectedSalesPopoverResultsPage(rowId))
  const page: number = useSelector(selectSearchResultsPage);
  const [firstAPICall, setFirstAPICall] = useState(false);
  const selectedSearchedPerson = useSelector(selectSearchedPerson);
  const searchedMultiSalesPerson = useSelector(selectSearchedMultiSalesPerson);
  const searchedMultiSalesPersonLoading = useSelector(selectSearchedMultiSalesPersonLoading);
  const [extendedAlignmentPersonId, setExtendedAlignmentPersonId] = useState<number | null>(null);
  const [disabledPersonId, setDisabledPersonId] = useState<number | null>(null);
  const [hasFetchedStaff, setHasFetchedStaff] = useState(false);

  useEffect(() => {
    if (!hasFetchedStaff && currentCompanyId > 0) {
      dispatch(actions.addAlignmentPeople({
        query: '',
        companyId: currentCompanyId,
        page: 1,
        screenName: 'multiSales',
        rowId,
      }));
      setHasFetchedStaff(true);
    }
  }, [currentCompanyId, hasFetchedStaff, rowId, dispatch]);

  const getSalesAlignment = (addedPersonId: number, addedPersonType?: string) => {
    // Adding people one-by-one: send only the newly added person id in `personId`.
    // `personIds` must NOT be included here; it is reserved for affinity-person change only.
    if (addedPersonType === 'LIVESEARCH') {
      setExtendedAlignmentPersonId(addedPersonId);
      dispatch(actions.getSearchedPersonProfileInsights({
        personId: addedPersonId,
        type: addedPersonType,
        affinity_person: basePersonId,
        alignmentType: 'sales',
        rowId: rowId,
      }))

    } else {
      dispatch(actions.getMultipleSalesAlignment({
        personId: addedPersonId,
        rowId,
        ...(
          (rowId > 0 || (rowId === 0 && searchedPersonSelected))
            ? { affinityPerson: basePersonId }
            : {}),
      }));

      closePopover();
      setQuery('');
    }
  }
  // for extended search
  useEffect(() => {
    if (searchedMultiSalesPerson?.person?.personId && searchedMultiSalesPerson.rowId === rowId) {
      if (searchedMultiSalesPerson?.person?.notification === "Profile does not exists.") {
        dispatch(helperActions.setNotification({
          message: searchedMultiSalesPerson?.person?.notification,
          proTip: false,
          rightPlacement: false,
          groupId: 0,
          classnameFlag: false,
        }))
        setDisabledPersonId(extendedAlignmentPersonId);
      } else {
        closePopover();
        dispatch(actions.getMultipleSalesAlignment({
          personId: searchedMultiSalesPerson?.person?.personId,
          rowId,
          ...(
            (rowId > 0 || (rowId === 0 && searchedPersonSelected))
              ? { affinityPerson: basePersonId }
              : {}),
        }));
        setQuery('');
      }

    }
  }, [searchedMultiSalesPerson])

  const onSearching = (q: string) => {
    setQuery(q);

    if (q.trim() === '') {
      return;
    } else {
      const searchQuery = validateSearchQuery(q.trim());
      if (searchQuery.length === 0) {
        return;
      }
      const obj: SearchResultsRequest = {
        query: searchQuery.trim(),
        screenName: 'person',
        page: 1,
        defaultLanguage: getLangCookie(),
        from: "multiSales",
        searchContext: 'sales',
        rowId: rowId,
      };
      setFirstAPICall(true);
      dispatch(affinityActions.affinityPopoverSearchResultsReset({
        searchContext: 'sales',
        rowId: rowId,
      }))
      dispatch(affinityActions.multiSalesAffinitySearchLoading(obj));
    }
  };

  const fetchMoreStaff = () => {
    if (query.trim() === '') {
      if (currentCompanyId !== 0) {
        dispatch(actions.addAlignmentPeople({
          companyId: currentCompanyId,
          page: staffPage,
          query,
          screenName: 'multiSales',
          rowId: rowId
        }));
        return;
      }
    } else {
      const searchQuery = validateSearchQuery(query.trim());
      if (searchQuery.length === 0) {
        return;
      }
      const obj: SearchResultsRequest = {
        query: searchQuery.trim(),
        screenName: 'person',
        page: salesPage + 1,
        defaultLanguage: getLangCookie(),
        from: "multiSales",
        searchContext: 'sales',
        rowId: rowId,
      };
      setFirstAPICall(false);
      dispatch(affinityActions.multiSalesAffinitySearchLoading(obj));
    }
  };
  return (
    <ContentWrapper
      className={classNames("sales-alignment-popover", {
        noStaff: staffData.length === 0,
      })}
    >
      <AlignmentPopoverList
        staff={staffData}
        totalStaff={totalStaff}
        loading={staffLoading}
        searchLoading={loading}
        extendedLoading={extendedLoading}
        searchLoaded={loaded}
        extendedLoaded={extendedLoaded}
        searchData={peopleData?.persons ?? []}
        totalSearchCount={totalSearchCount}
        disabledIds={disabledIds}
        onSelect={getSalesAlignment}
        onFetchMore={fetchMoreStaff}
        onSearching={onSearching}
        query={query}
        scrollContainerId={`scrollPeople-multisales-${rowId}`}
        firstAPICall={firstAPICall}
        currentCompanyId={currentCompanyId ?? 0}
        spinnerLoading={searchedMultiSalesPersonLoading}
        disabledPersonId={disabledPersonId ?? 0}
      />
    </ContentWrapper >
  );
};

SalesAlignmentPopover.defaultProps = defaultProps;
export default SalesAlignmentPopover;
